import { CR_SUBMISSION } from '../constants';
import { getCurrentSelectedRatingHint } from './get-current-selected-rating-hint';

export type ResetRatingHintHandlerParams = {
    rootElement: Pick<HTMLElement, 'querySelectorAll' | 'querySelector'>;
};
export const ResetRatingHintHandler = ({ rootElement }: ResetRatingHintHandlerParams) => {
    const hintSpan = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.HINT_SELECTOR);

    return () => {
        if (hintSpan === null) return;

        hintSpan.innerText = getCurrentSelectedRatingHint({ rootElement });
    };
};
